import apiService from 'v2/services/api';

import type { AxiosResponse } from 'axios';
import type { IApiResponse } from 'interfaces/IApiResponse';

export const agent = {
  get<T = any>(url: string, params?: any, headers?: any): Promise<AxiosResponse<IApiResponse<T>>> {
    return apiService.get(url, params, headers, true).toPromise();
  },
  post<T = any>(url: string, body: any, headers?: any): Promise<AxiosResponse<IApiResponse<T>>> {
    return apiService.post(url, body, headers, true).toPromise();
  },
  put<T = any>(url: string, body: any, headers?: any): Promise<AxiosResponse<IApiResponse<T>>> {
    return apiService.put(url, body, headers, true).toPromise();
  },
  del<T = any>(url: string, params?: any, headers?: any): Promise<AxiosResponse<IApiResponse<T>>> {
    return apiService.delete(url, params, headers, true).toPromise();
  },
};
